import { Vertical } from '@wix/package-picker-shared';
import { CreativeOffer } from '@wix/premium-purchase-platform/@sdk';

const VERTICAL_TO_TRANSLATION_KEY_SUBSTRING: Partial<Record<Vertical, string>> =
  {
    [Vertical.Bookings]: 'Verticals_Bookings',
    [Vertical.Stores]: 'Verticals_Stores',
    [Vertical.Events]: 'Verticals_Events',
    [Vertical.Restaurants]: 'Verticals_Restaurants',
    [Vertical.Fitness]: 'Verticals_Fitness',
    [Vertical.Video]: 'Verticals_Video.Music.Art',
    [Vertical.Music]: 'Verticals_Video.Music.Art',
    [Vertical.ArtStore]: 'Verticals_Video.Music.Art',
    [Vertical.OnlinePrograms]: 'online_programs',
  };

interface ArrangeFeaturesGridNamespacesParams {
  namespaces?: CreativeOffer.GridNamespace[];
  intent?: Vertical;
  isIntentBasedPromotionEnabled: boolean;
}

interface ArrangeFeaturesGridNamespacesResult {
  primaryNamespaces: CreativeOffer.GridNamespace[];
  ternaryNamespaces: CreativeOffer.GridNamespace[];
}

export const arrangeFeaturesGridNamespaces = ({
  namespaces,
  intent,
  isIntentBasedPromotionEnabled,
}: ArrangeFeaturesGridNamespacesParams): ArrangeFeaturesGridNamespacesResult => {
  const isVisibleOnDesktop = (ns: CreativeOffer.GridNamespace) =>
    ns.metadata?.displayInDesktop !== 'false';

  const primaryNamespaces =
    namespaces?.filter(
      (ns) =>
        ns.displayProperties?.priority !== CreativeOffer.Priority.TERNARY &&
        isVisibleOnDesktop(ns),
    ) ?? [];
  const ternaryNamespaces =
    namespaces?.filter(
      (ns) =>
        ns.displayProperties?.priority === CreativeOffer.Priority.TERNARY &&
        isVisibleOnDesktop(ns),
    ) ?? [];

  const intentSubstring =
    isIntentBasedPromotionEnabled && intent
      ? VERTICAL_TO_TRANSLATION_KEY_SUBSTRING[intent]
      : undefined;
  const promotedNamespace = intentSubstring
    ? ternaryNamespaces.find((ns) =>
        ns.content?.name?.translationKey?.includes(intentSubstring),
      )
    : undefined;

  if (!promotedNamespace) {
    return { primaryNamespaces, ternaryNamespaces };
  }

  return {
    primaryNamespaces: [...primaryNamespaces, promotedNamespace],
    ternaryNamespaces: ternaryNamespaces.filter(
      (ns) => ns !== promotedNamespace,
    ),
  };
};
